<template>
  <div>
    <div class="bt">
      <span>联系我们</span>
      <p>SCOPE OF BUSINESS</p>
    </div>
    <el-form
      ref="form"
      :model="form"
      style="width: 900px; margin: auto"
      label-width="0px"
    >
      <el-form-item label="">
        <el-input placeholder="姓名" v-model="form.name"></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-input placeholder="工作单位" v-model="form.region"></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-input placeholder="联系电话" v-model="form.phone"></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-input
          placeholder="留言"
          :rows="10"
          type="textarea"
          v-model="form.desc"
        ></el-input>
      </el-form-item>

      <el-form-item style="text-align: center">
        <el-button
          style="width: 120px; margin-bottom: 50px"
          type="primary"
          @click="PostInsetleaveword"
          >提交</el-button
        >
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import WOW from "wowjs";
import { insetleaveword } from "@/api/patient.js";
export default {
  components: {},
  name: "lx",
  data() {
    return {
      form: {
        name: "",
        region: "",
        phone: "",
        desc: "",
      },
    };
  },
  mounted() {
    setTimeout(() => {
      let wow = new WOW.WOW({
        boxClass: "wow",
        animateClass: "animated",
        offset: 100,
        mobile: false,
        live: true,
      });
      wow.init();
    }, 200);
  },
  methods: {
    PostInsetleaveword() {
      if (
        this.form.name == "" ||
        this.form.region == "" ||
        this.form.phone == "" ||
        this.form.desc == ""
      ) {
        return this.$message({ type: "warning", message: "有选项未填写" });
      }
      let data = new FormData();
      data.append("workunit", this.form.region);
      data.append("name", this.form.name);
      data.append("contactway", this.form.phone);
      data.append("leaveword", this.form.desc);
      insetleaveword(data).then((res) => {
        if (res.code == "OK") {
          this.$message({ type: "success", message: res.msg });
          this.form.region = "";
          this.form.name = "";
          this.form.phone = "";
          this.form.desc = "";
        }
      });
    },
  },

  watch: {},
};
</script>
<style scoped>
>>> .el-input__inner {
  height: 60px;
}
</style>
<style lang="scss" scoped>
.bt {
  padding-top: 70px;
  margin: auto;
  text-align: center;

  span {
    font-size: 26px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #333333;
  }

  p {
    margin-top: 5px;
    margin-bottom: 20px;
    font-size: 20px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
  }
}
</style>
